import styled from '@emotion/styled';

import { gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const StyledItemsListContainer = styled.form`
    margin-top: -${gutterSizes.base};
`;
